export default __webpack_public_path__ + "static/work-459853f931a7c84ea205052d3a4b192c.svg";